/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum SampleRequestProjectType {
  NEW_FORMULA_DEVELOPMENT = "new_formula_development",
  FORMULA_ENHANCEMENT = "formula_enhancement",
  TROUBLESHOOTING_EXISTING_FORMULA = "troubleshooting_existing_formula",
  EXPLORING_RAW_MATERIALS_FOR_EXISTING_FORMULA = "exploring_raw_materials_for_existing_formula",
  EXPLORING_ALTERNATE_RAW_MATERIALS_FOR_EXISTING_FORMULA = "exploring_alternate_raw_materials_for_existing_formula",
}
